// Accesso allo storage del browser che non puo' far cadere l'applicazione.
//
// PERCHE' ESISTE (2026-09-02). Nel browser interno di Facebook e di Instagram
// — cioe' dove atterra il traffico degli annunci — localStorage puo' lanciare
// invece di rispondere: storage isolato, cookie di terze parti bloccati,
// modalita' privata. In quel caso `localStorage.getItem(...)` solleva una
// DOMException SecurityError.
//
// Una di quelle letture, hasStoredSession in hooks/useAuth.js, veniva eseguita
// durante il render di AuthProvider, che avvolge tutta l'applicazione: quando
// lanciava, React non montava NIENTE e il visitatore vedeva una pagina bianca.
// Verificato riproducendolo, ed e' cosi' dal primo commit: il bundle di oggi,
// quello di ieri e quello pre-tema si comportano tutti allo stesso modo.
//
// LA REGOLA, che vale per ogni bivio che dipenda dallo storage:
//
//     quando lo storage non risponde il valore e' "NON LO SO",
//     e "non lo so" porta SEMPRE al modulo di registrazione —
//     mai al login, mai a una pagina vuota.
//
// Chi non e' registrato deve poter completare l'iscrizione anche senza storage
// disponibile. Se non riusciamo a sapere se un account esiste gia', il posto
// sicuro e' il modulo, non il muro.
//
// In pratica: la lettura restituisce null (indistinguibile da "non c'e'
// niente"), la scrittura non fa niente e non lancia. Nessun chiamante deve
// avere il proprio try/catch: e' quello il punto di queste due funzioni.
// Convertire le altre letture sparse per il codice diventa cosi' una
// sostituzione meccanica invece di diciotto ragionamenti separati.

export function safeGetItem(chiave, deposito = 'local') {
  try {
    const s = deposito === 'session' ? window.sessionStorage : window.localStorage;
    return s.getItem(chiave);
  } catch {
    return null;
  }
}

export function safeSetItem(chiave, valore, deposito = 'local') {
  try {
    const s = deposito === 'session' ? window.sessionStorage : window.localStorage;
    s.setItem(chiave, valore);
    return true;
  } catch {
    // Silenzio deliberato: una scrittura che fallisce non deve mai fermare il
    // percorso dell'utente. Chi ha bisogno di sapere se e' andata a buon fine
    // guarda il valore restituito.
    return false;
  }
}

export function safeRemoveItem(chiave, deposito = 'local') {
  try {
    const s = deposito === 'session' ? window.sessionStorage : window.localStorage;
    s.removeItem(chiave);
    return true;
  } catch {
    return false;
  }
}

// Se lo storage e' del tutto inaccessibile, chi deve decidere sa di non
// sapere, invece di dedurlo da un null che significherebbe "e' vuoto".
export function storageDisponibile(deposito = 'local') {
  try {
    const s = deposito === 'session' ? window.sessionStorage : window.localStorage;
    const k = '__lc_prova__';
    s.setItem(k, '1');
    s.removeItem(k);
    return true;
  } catch {
    return false;
  }
}
